import { ACCOUNT_STATUSES } from 'common/constants';

export const getMultistepConfig = (isMultiStepFlow, isFirstStep, account) => {
  const isUserPartiallyRegistered = account?.status === ACCOUNT_STATUSES.PARTIALLY_REGISTERED;
  const showSignInLink = !isMultiStepFlow || (isFirstStep && !isUserPartiallyRegistered);
  const headerTitle = isMultiStepFlow
    ? isFirstStep
      ? 'create_account'
      : 'multistep_reg_title'
    : 'create_account';

  return {
    headerTitle,
    showSignInLink,
  };
};
